<template>
  <div class="dangan-tab">
    <div class="list-wrapper">
      <!-- <ul class="tabnav-category" @click="$emit('showPicker')">
        <span>{{ $t("base.category") }}：</span>
        <li :class="{ active: !category }">{{ $t("base.allcategory") }}</li>
        <li class="active" v-if="category">{{ category }}</li>
      </ul> -->
      <Search
        :filterList="searchFilter"
        @search="subminSearch"
        @offsearch="offSearch"
      ></Search>
      <m-textArea class="data-list" ref="dataList">
        <div class="picture-list">
          <div
            v-for="(item, index) in datalist"
            :key="index"
            class="picture-item"
            @click="showPic(item)"
          >
            <div class="picture-main">
              <img :src="item.preview_url" />
            </div>
            <div class="picture-tt">
              {{ item.title }}
            </div>
          </div>
        </div>
      </m-textArea>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </div>

    <PicShow
      v-if="picPage"
      :content="content"
      :headers="headers"
      @close="picPage = false"
    ></PicShow>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Search from "@/components/Search.vue";
import GisBtn from "@/components/GisBtn.vue";
import TextArea from "@/components/TextArea";
import Pagination from "@/components/Pagination";
import PicShow from "@/components/PicShow";

export default {
  props: {
    tabData: Object,
    category: String
  },
  components: {
    Search,
    GisBtn,
    "m-textArea": TextArea,
    Pagination,
    PicShow
  },
  data() {
    return {
      pageName: "archive",
      onSearch: false,
      searchFilter: [
        { name: "title", title: "标题" },
        { name: "category", title: "类别" },
        { name: "region", title: "地域" },
        { name: "age", title: "年代" },
        { name: "keywords", title: "关键词" },
        { name: "comment", title: "简介" }
      ],
      searchParam: {},
      picPage: false,
      content: {},
      headers: [
        { tag: "title", name: "标题" },
        { tag: "category", name: "类别" },
        { tag: "age", name: "年代" },
        { tag: "region", name: "地域" },
        { tag: "broken", name: "完残" },
        { tag: "material", name: "材质" },
        { tag: "size", name: "尺寸" },
        { tag: "status", name: "现状" },
        { tag: "rank", name: "级别" },
        { tag: "source", name: "来源" },
        { tag: "keywords", name: "关键词" },
        { tag: "comment", name: "简介" },
        { tag: "view_count", name: "点击率" },
        { tag: "no", name: "登记号" },
        { tag: "collected_date", name: "入藏时间" },
        { tag: "collected_address", name: "入藏地点" }
      ],
      gisurl:
        "http://amap.zju.edu.cn/maps/3275/mobile?from=timeline&isappinstalled=0"
    };
  },
  computed: {
    ...mapState(["archive"]),
    datalist() {
      if (this.onSearch) {
        return this.archive.searchres.content;
      }
      return this.archive[this.pageNow];
    },
    pageNow() {
      return this.onSearch
        ? this.archive.searchres.number
        : this.archive.number;
    },
    pages() {
      return this.onSearch
        ? this.archive.searchres.total_pages
        : this.archive.total_pages;
    },
    title() {
      return this.tabData.ttimg;
    }
  },
  mounted() {
    this.getPageData();
  },
  watch: {
    category: function(c, oldc) {
      if (c === oldc) {
        return;
      }
      this.subminSearch(this.searchParam);
    }
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_size: 24,
        page_num
      };
      if (this.category) {
        param.category = this.category;
      }
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.$refs.dataList.scroll();
    },
    search(param, num = 0) {
      const query = {
        data_name: this.pageName,
        page_size: 24,
        page_num: num,
        ...param
      };
      if (this.category) {
        query.category = this.category;
      }
      this.searchData(query);
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(data) {
      this.search(data);
      this.$refs.dataList.scroll();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.searchParam = {};
      this.$refs.dataList.scroll();
    },
    showPic(data) {
      this.content = data;
      this.picPage = true;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.dangan-tab {
  display: flex;
  height: 100%;
  padding: 1rem;
  overflow: hidden;

  .list-wrapper {
    flex: 5;
    display: flex;
    flex-direction: column;
  }

  .tabnav-category {
    margin: 0;
    padding: 0 0.5rem 0.5rem;
    font-size: 0.875rem;

    li {
      display: none;
      padding: 0 0.5rem;
      line-height: 1.2;

      &.active {
        display: inline-block;
        color: $primary;
        font-weight: 700;
      }

      &:first-child {
        margin-left: -0.75rem;
      }

      &::after {
        content: "";
        display: inline-block;
        margin-top: 0.35rem;
        margin-left: 0.5rem;
        width: 0.5rem;
        height: 0.3rem;
        background-image: url("~@/assets/img/arrow-down.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        vertical-align: top;
      }
    }
  }

  .data-list {
    flex: 1;
    margin-top: 1rem;
    margin-bottom: 1rem;

    .text-main {
      padding: 0 0 1rem;
    }
  }

  .picture-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 0.5rem;
  }

  .picture-item {
    width: 48%;
    margin-bottom: 0.65rem;
    padding: 0.5rem;
    background-color: #d2c2a3;

    .picture-main {
      height: 6rem;
      text-align: center;
      line-height: 6rem;
      img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }

    .picture-tt {
      font-size: 0.75rem;
      text-align: center;
    }
  }

  .picture-wrapper {
    z-index: 20;
  }
}
</style>
